const replaceCommaWithPeriod = (value: string) => {
  return value.replace(/,/g, '.');
};

const validateEmail = (value: string) => {
  const pattern = /^[A-Z0-9_.+-]+@[A-Z0-9_.-]+\.[A-Z]{2,}$/i;
  return pattern.test(value);
};

const validateOnlyWhitespace = (value: string) => {
  const pattern = /^\s+$/;
  return pattern.test(value);
};

export { replaceCommaWithPeriod, validateEmail, validateOnlyWhitespace };
